import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
//LOL!
import populatePath from "../tiny-functions/populatePath";
import getOname from "../tiny-functions/getOname";
import getSchemaName from "../tiny-functions/getSchemaName";
import * as api from "../services/api";
import * as codebook from "../services/codebook";
import store from "store";

import ErrorBox from "../../common/components/ErrorBox";
import LoadingBox from "../../common/components/LoadingBox";
import * as propertyTypes from "../propertyTypes";

import { ApiUnreachable, InvalidToken } from "../services/error";

var hidden, visibilityChange;
if (typeof document.hidden !== "undefined") {
  // Opera 12.10 and Firefox 18 and later support
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

const loadContent = function (
  path,
  InnerComponent,
  additionalConnect,
  loadOnInterval
) {
  const DataAccessComponent = (props) => {
    const oName = getOname(path);
    const schemaName = getSchemaName(path);

    const getSchema = () => {
      const schemaName = getSchemaName(path);
      return props.schema[schemaName].props;
    };

    const getCodebook = async (path: string) => {
      const oName = getOname(path);
      if (oName in props.codebook) {
        return props.codebook[oName];
      } else {
        let codebookResponse;
        if (/\//.test(path)) {
          codebookResponse = await codebook.downloadURL(path);
        } else {
          codebookResponse = await codebook.download(oName);
        }

        if (codebookResponse == null) {
          throw new Error("codebook download returned null");
        }
        return codebookResponse;
      }
    };

    const getList = (callback, fallback, modifier = "ASC") => {
      if (
        path.split("/").length > 1 &&
        path.split("/").slice(-1)[0].split(".").length > 1
      ) {
        throw new Error(
          "Endpoint " +
            path +
            " is not a list but an object. Cannot getList on object."
        );
      }

      const internalGetData = (
        propName: string,
        id: number,
        show: "label" | "display" | "value" = "display"
      ) => {
        if (show === "value") {
          return props.data[oName][id].props[propName];
        } else if (show === "display") {
          return getDisplay(oName, id, propName);
        } else if (show === "label") {
          let propSchema = props.schema[schemaName].props[propName];
          if (propSchema == null || propSchema.label == null) {
            throw new Error("propSchema.label is null");
          }
          return propSchema.label;
        } else {
          throw new Error("Invalid parameter [" + show + "]");
        }
      };
      const parentName = path.split("/").slice(-2)[0].split(".")[0];
      const parentID = props.ids[parentName];
      const propData = props.data[parentName][parentID];

      if (propData.children == null) {
        throw new Error("propData dont have children");
      }

      let ids = propData.children[oName].ids;
      ids = ids.sort();

      if (typeof modifier === "string" && modifier === "DESC") {
        ids.reverse();
      } else if (_.isFunction(modifier)) {
        ids = modifier(ids, (propName, id, show) =>
          internalGetData(propName, id, show)
        );
      }

      if (ids.length === 0) {
        if (fallback == null) {
          return [];
        }

        return fallback();
      }

      //This is a little mind blowing because it's a callback inside a callback, but getList should work like Array.prototype.map works
      // and how the internalGetData should work like getData work for displays
      let returnArray = [];
      for (let id of ids) {
        let callbackReturn = callback(
          (propName, show = "display") => internalGetData(propName, id, show),
          id
        );

        //Should I review this condition? Maybe accept just objects (React elements / JSX)
        if (callbackReturn != null || callbackReturn !== false) {
          returnArray.push(callbackReturn);
        }
      }

      return returnArray;
    };

    const getData = (
      propName: string,
      show: "label" | "display" | "value" = "display"
    ) => {
      const oName = getOname(path);
      if (show === "label") {
        let propSchema = props.schema[schemaName].props[propName];
        if (propSchema == null || propSchema.label == null) {
          throw new Error("Something went wrong");
        }
        return propSchema.label;
      }
      let id;
      if (oName in props.ids) {
        id = props.ids[oName];
      } else {
        const parentName = path.split("/").slice(-2)[0].split(".")[0];

        const parentID = props.ids[parentName];
        if (
          "children" in props.data[parentName][parentID] &&
          oName in props.data[parentName][parentID].children
        ) {
          if (
            props.data[parentName][parentID].children[oName].ids.length === 1
          ) {
            id = props.data[parentName][parentID].children[oName].ids[0];
          } else {
            id = null;
          }
        } else {
          return null;
        }
      }

      if (
        !(oName in props.data) ||
        id == null ||
        !(id in props.data[oName]) ||
        !("props" in props.data[oName][id])
      ) {
        return null;
      }

      if (show === "value") {
        return props.data[oName][id].props[propName];
      } else if (show === "display") {
        if (!(id in props.data[oName]) || !("props" in props.data[oName][id])) {
          return null;
        }

        return getDisplay(oName, id, propName);
      } else {
        throw new Error("Invalid parameter [" + show + "]");
      }
    };

    const getDisplay = (oName: string, id: number, propName: string) => {
      let propSchema = props.schema[schemaName].props[propName];
      if (propSchema == null || propSchema.type == null) {
        throw new Error(
          "Schema prop is null. Does [ " +
            propName +
            "] exists on [" +
            oName +
            "] ?"
        );
      }
      let propType = propSchema.type;

      if (
        propType === propertyTypes.OPEN_INPUT ||
        propType === propertyTypes.PRIMARY_KEY
      ) {
        return props.data[oName][id].props[propName];
      } else if (propType === propertyTypes.CODEBOOK) {
        //rowOfInterest= state.services.codebook[codebookName].get(codebookID);
        // state.services.schema[codebookName].props

        //Temporary solution, need to code codebook.
        //the Ideal would be that the API specifies which columns from codebook should be joined and what should be the glue
        return props.data[oName][id].props[propName];
      } else if (propType === propertyTypes.SELECT_OPTION) {
        let dropdownOptions = propSchema.dropdownOptions;
        if (dropdownOptions == null)
          throw new Error("dropdownOptions is null on property: " + propName);
        for (let option of dropdownOptions) {
          if (Array.isArray(option)) {
            if (
              String(option[0]) ===
              String(props.data[oName][id].props[propName])
            ) {
              return option[1];
            }
          } else {
            if (
              String(option) === String(props.data[oName][id].props[propName])
            ) {
              return option;
            }
          }
        }
        throw new Error(
          "getDisplay did not find a valid option on schema for prop: " +
            propName
        );
      } else if (propType === propertyTypes.BOOLEAN) {
        if (props.data[oName][id].props[propName] === true) {
          return "On";
        } else if (props.data[oName][id].props[propName] === false) {
          return "Off";
        }
        throw new Error(
          "Value received by fillContent should be boolean but is not."
        );
      } else {
        throw new Error(
          "Did not found property type on fillContent function for property: " +
            propName
        );
      }
    };

    return (
      <InnerComponent
        getData={getData}
        getList={getList}
        getSchema={getSchema}
        getCodebook={getCodebook}
        additionalConnect={props.additionalConnect}
        {...props}
      />
    );
  };

  const mapStateToProps = (state: storeState) => {
    if (additionalConnect != null) {
      var addMe = additionalConnect(state);
      return {
        additionalConnect: {
          ...addMe,
        },
        data: state.data,
        schema: state.services.schema,
        codebook: state.services.codebook,
        sessionids: state.services.ids,
      };
    } else {
      return {
        additionalConnect: {},
        data: state.data,
        schema: state.services.schema,
        codebook: state.services.codebook,
        sessionids: state.services.ids,
      };
    }
  };

  const ConnectedDataAccessComponent = connect(mapStateToProps)(
    DataAccessComponent
  );

  return class FetcherComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loading: true,
        error: "",
        oldIDs: {},
        refresherInstalled: false,
      };
      this.ids = {};

      this.handleVisibilityChange = () => {
        if (!document[hidden]) {
          //Interval - once in two hours the data will get refreshed
          //Just to be sure that the client don't get misleading info if app runs too long on background
          this.loadData().catch((e) => {
            if (e instanceof ApiUnreachable) {
              this.setState({
                error:
                  "Either you don't have Internet access or our servers are unavailable. Please try again later.",
              });
            } else if (e instanceof InvalidToken) {
              this.setState({ loading: true });
            } else {
              this.setState({
                error: "-",
              });
              throw e;
            }
          });
        }
      };
    }

    fetch = () => {
      this.loadDataOnInterval().catch((e) => {
        if (e instanceof ApiUnreachable) {
          this.setState({
            error:
              "Either you don't have Internet access or our servers are unavailable. Please try again later.",
          });
        } else if (e instanceof InvalidToken) {
          this.setState({ loading: true });
        } else {
          this.setState({
            error: "-",
          });
          throw e;
        }
      });
    };

    componentDidMount() {
      this.mounted = true;
      this.findIDs();
      this.loadData().catch((e) => {
        if (e instanceof ApiUnreachable) {
          this.setState({
            error:
              "Either you don't have Internet access or our servers are unavailable. Please try again later.",
          });
        } else if (e instanceof InvalidToken) {
          this.setState({ loading: true });
        } else {
          this.setState({
            error: "-",
          });
          throw e;
        }
      });
      if (loadOnInterval) {
        this.interval = setInterval(this.fetch, 1000);
      }
      if (
        this.props.refresher != null &&
        visibilityChange != null &&
        hidden != null
      ) {
        this.setState({ refresherInstalled: true });
        document.addEventListener(
          visibilityChange,
          this.handleVisibilityChange,
          false
        );
      }
    }

    componentDidUpdate() {
      this.findIDs();
      if (_.isEqual(this.ids, this.state.oldIDs) === false) {
        this.setState({ loading: true });

        this.loadData().then(() => {
          this.setState({ loading: false });
        });
      }
    }

    componentWillUnmount() {
      if (loadOnInterval) {
        clearInterval(this.interval);
      }
      this.mounted = false;
      if (this.state.refresherInstalled) {
        document.removeEventListener(
          visibilityChange,
          this.handleVisibilityChange,
          false
        );
      }
    }

    findIDs = () => {
      const sessionids = store.getState().services.ids;
      for (const element of path.split("/")) {
        const [oName, idText] = element.split(".");
        if (idText === "session") {
          if (oName in sessionids) {
            this.ids[oName] = sessionids[oName];
          } else {
            return false;
          }
        } else if (idText === "props") {
          if (oName in this.props.pathids) {
            this.ids[oName] = this.props.pathids[oName];
          } else {
            throw new Error("id not in pathids");
          }
        } else if (idText != null && idText.length > 0) {
          this.ids[oName] = idText;
        }
      }
    };

    loadDataOnInterval = async () => {
      const endpoint = populatePath(path, this.ids);
      await api.load(endpoint);
      return true;
    };

    loadData = async () => {
      this.setState({ loading: true, oldIDs: { ...this.ids } });
      const endpoint = populatePath(path, this.ids);
      await api.load(endpoint);
      if (this.mounted === true) {
        this.setState({ loading: false });
      }
      return true;
    };

    render() {
      //This destruction is necessary to not overwrite inner loadContent with outer loadContent in the app
      const {
        data,
        schema,
        codebook,
        sessionids,
        getData,
        getList,
        getSchema,
        getCodebook,
        ids,
        pathids,
        ...passThroughProps
      } = this.props;

      if (this.state.error !== "") {
        return <ErrorBox reload>{this.state.error}</ErrorBox>;
      }

      if (this.state.loading === true) {
        return <LoadingBox />;
      } else {
        return (
          <ConnectedDataAccessComponent ids={this.ids} {...passThroughProps} />
        );
      }
    }
  };
};

export default loadContent;
